<app-loader></app-loader>
<p-toast></p-toast>
<div *ngIf="isFirstTimeHit" class="gate-main-outer">
    <h4 [ngClass]="{ 'not-connected': gateStatusError, 'gate-open': isGateOpenOrClosed }"> {{ gateStatusError ?
        errorText : 'Gate is ' + (isGateOpenOrClosed ? 'opened!' : 'closed!') }}</h4>
    <div class="turk-logo" [ngClass]="{'default-truk-logo': !parkingLotDetails?.companyLogo}">
        <img [ngClass]="{'default-parking-image': !parkingLotDetails?.companyLogo}" [src]="parkingLotDetails?.companyLogo? parkingLotDetails?.companyLogo : '../../assets/images/Ticket Detail.png'"
                alt="" />
    </div>
    <div class="img-outer">
        <img class="parking-image"
            [src]="parkingLotDetails?.imagePath?.length > 0 ? parkingLotDetails?.imagePath[0] : '../../assets/images/default-parkingLot-sq.svg'"
            alt="" />

        <p *ngIf="parkingLotDetails?.parkingLotName" class="parking-name">{{parkingLotDetails?.parkingLotName}}</p>
    </div>
    <div class="grey-bg" [ngClass]="{ 'grey-bg-access': isShowAccessCode }">
        <h3 *ngIf="parkingLotDetails?.driverName">{{parkingLotDetails?.driverName}}</h3>
        <div *ngIf="!isShowAccessCode">
            <div class="btn-outer">
                <h5>Press the button below</h5>
                <p> to open the gate.</p>
            </div>
            <div class="press-progress-bar">
                <div class="circle-container">
                    <circle-progress [percent]="progress" [radius]="100" [outerStrokeWidth]="20"
                        [outerStrokeColor]="'#0066FF'" [innerStrokeWidth]="20" [showSubtitle]="false"
                        [showTitle]="false" [showUnits]="false" [animation]="true" [animationDuration]="300"
                        [startFromZero]="false" [responsive]="false" [showInnerStroke]="true"
                        [innerStrokeColor]="'#DCDCDC'" [space]="-20" [showBackground]="false">
                    </circle-progress>
                    
                    <div class="inner-ring"></div>
                    
                    <div class="center-label" class="center-label" [ngClass]="{ 'disabled': gateStatusError }"
                        (click)="!(gateStatusError) && startHold()">
                        <div class="white-bg"><span class="dark-grey"><span class="light-grey">
                                    <h5 class="no-select">Press</h5>
                                </span></span></div>
                    </div>
                </div>

            </div>

        </div>
        <div *ngIf="isShowAccessCode" class="access-code-container access-code-outer">
            <h5>Alternatively, you may use the following access code to open the gate:</h5>
            <p>{{ accessCode }}</p>
        </div>
        <div class="refresh-link">
            <button (click)="checkOpenGateStatus(bookingId, true)">Refresh</button>
        </div>
    </div>